import React, { useEffect, useState } from "react";
import { Box, Card, Grid, Rating, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarContainer } from "../../../component/organism";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { QuizAttemptCard, QuizMainCard } from "../../../component/molecule";
import { QuizFirstCard } from "../../../component/molecule";
import { CircularWithValueLabel, TextIconButtonComponent } from "../../../component/atom";
import { connect } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import { IconButtonComponent } from "../../../component/atom";
import moment from 'moment';
import _, { size } from "lodash";
import { USER_ROLE } from "../../../core/Constant";
import BellCurveGraph from "./ResultInGraph";
import ResultSummary from "./ResultSummary";
import BellCurveBarSummary from "./ResultSummaryBarDisplay";
import ClusterBarChart from "./ClusterResultSummary";



const ResultInGraphScreen = ({ stdgetquizAttempts, attemptsData, getStudentsGraphData = () => { }, studentsGraphData = {}, studentCategoryGraphData = [], }) => {
    const navigate = useNavigate();
    const [newquiz, setQuiz] = useState('');
    const [attempts, setAttempts] = useState([]);
    const location = useLocation();
    const [userType, setUserType] = useState(1);
    const [mainQS, setMainQS] = useState([]);
    const [mainQSMark, setMainQSMark] = useState([]);
    const [userMark, setUserMark] = useState(NaN);
    const [categoryListMark, setCategoryListMark] = useState([]);
    const [quizPercentile, setQuizPercentile] = useState(NaN);

    useEffect(() => {
        getUserType()
        // console.log("scatterData ",scatterData)
    }, []);

    const getUserType = async () => {
        const type = localStorage.getItem('userType');
        setUserType(type)
    };


    useEffect(() => {
        setCategoryListMark(studentCategoryGraphData);
    }, [studentCategoryGraphData]);

    useEffect(() => {
     
        const list = _.get(studentsGraphData, 'all_marks', [])
        setMainQSMark(list);
        
        // setMainQS(_.map(list, (item, index) => index + 1))
        // const myMark = _.get(studentsGraphData, 'student_marks', 0);
        // const index = _.findIndex(list, i => i == myMark)
        setUserMark(_.get(studentsGraphData,'student_marks',NaN));
        setQuizPercentile(_.get(studentsGraphData,'quizPercentile',NaN));
    }, [studentsGraphData])

    useEffect(() => {
        const qId = location.state?.quiz;
        setQuiz(qId)
        getStudentsGraphData(qId?.id);
        // stdgetquizAttempts(qId?.id);
    }, [location]);

    // Chart.js data object


    // Chart.js options


    return (< >
        <Box className="main-screen-container">
            <Box>
                <IconButtonComponent onclick={() => navigate(userType == USER_ROLE.admin ? -1 : '/quiz-attempt', { state: { quiz: location.state?.quiz } })} btnType="backbtn" btnText="Back" />
            </Box>
            {/* <Box>
        <HeadingComponent text={""} fontweigth={600} size={40} fontfamily={"Montserrat"} />
      </Box> */}
            <Box sx={{ display: 'flex', flexDirection: 'row', width: 1, justifyContent: 'space-between', mt: 2.5 }}>
                <Box>
                    <p className="quiz-attempt-text">{newquiz?.id < 10 ? 'Quiz 0' + newquiz?.id : newquiz?.id}</p>
                    <p className="quiz-attempt-subtext">{newquiz?.name}</p>
                </Box>

            </Box>
            <Box>
                <Grid container>
                    <Grid item sx={{ display: 'flex', justifyContent: 'center' }} xs={11} >
                        <HeadingComponent text={`Quiz Progress in Graph`} fontfamily={"Montserrat"} fontweigth={560} size={25} />
                    </Grid>
                    <Grid item sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', marginBottom:5 }} xs={12}>
                        <Grid container>
                            <Grid xs={11} sm={11} lg={11} item>
                                <Box pt={3}>
                                    <Typography fontFamily={'Montserrat'} variant="h5" sx={{fontWeight:'bold'}}>
                                    📊 Performance Overview
                                    </Typography>
                                    <Box sx={{marginTop:2}}>
                                  
                                    {/* <ResultSummary  studentMark={userMark} list={mainQSMark}/> */}
                                    <BellCurveBarSummary  studentMark={userMark} list={mainQSMark} barDisplay={true} quizPercentile={quizPercentile} />
                                    {/* <BellCurveGraph  studentMark={userMark} list={mainQSMark}/> */}
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    

                

                    <Grid item xs={11} sm={11} lg={11}>
                        {categoryListMark.length == 0 ?(<></>): (<>
                            <Typography fontFamily={'Montserrat'} variant="h5" sx={{fontWeight:'bold',paddingBottom:'1.5rem'}}>
                            📊 Quiz Cluster
                            </Typography>
                        {/* <Grid container> */}
                        {/* <Grid item xs={11}> */}
                            <ClusterBarChart data={categoryListMark} />
                        {/* </Grid> */}
             
                           
                        {/* </Grid> */}
                        </>)}
                    </Grid>
                </Grid>
            </Box>


        </Box>
    </>);
}

export default connect(state => ({
    attemptsData: state.quizes.get('attemptsData'),
    startData: state.quizes.get('startData'),
    studentsGraphData: state.quizes.get('studentsGraphData'),
    studentCategoryGraphData: state.quizes.get('studentCategoryGraphData'),
}),
    {
        stdgetquizAttempts: Actions.quizes.stdgetquizAttempts,
        getStudentsGraphData: Actions.quizes.getStudentsGraphData
    }
)(ResultInGraphScreen);

